import { LandingLayout } from "@web/components/LandingPage/LandingLayout"
import { PrivacyPolicy } from "@web/components/LandingPage/PrivacyPolicy/PrivacyPolicy"

const PrivacyPolicyPage: React.FC = () => {
  return (
    <LandingLayout>
      <PrivacyPolicy />
    </LandingLayout>
  )
}

export default PrivacyPolicyPage
